/* eslint-disable newline-before-return */
import { Predictions } from 'aws-amplify';
import { FC, useState, ChangeEvent } from 'react';
import { Button, Grid, TextArea, Dimmer, Loader } from 'semantic-ui-react';

// import useSentence from '../../hooks/Sentence';
import { Loading } from 'components/common';
import useSentence from 'hooks/Sentence';

const Component: FC = () => {
  const [en, setEn] = useState('');
  const [jp, setJp] = useState('');
  const { isLoading, register } = useSentence({ needToFetch: false });

  const onSumit = async () => {
    await register({
      jp,
      en,
      checked: 0, // デフォルトはチェックをOFF
    });
    setJp('');
    setEn('');
  };
  const translate = (text: string) => {
    if (text == '') return;
    Predictions.convert({
      translateText: {
        source: {
          text,
        },
      },
    })
      .then((result) => setJp(result.text))
      .catch((err) => console.log({ err }));
  };

  return (
    <>
      {isLoading && (
        <Dimmer active inverted>
          <Loader>Loading...</Loader>
        </Dimmer>
      )}
      <Grid>
        <Grid.Row>
          <TextArea
            placeholder="English Sentence"
            style={{ minHeight: 100, width: '100%' }}
            onChange={(event: ChangeEvent<HTMLTextAreaElement>) => {
              const value = String(event.target.value);
              setEn(value);
            }}
          />
        </Grid.Row>
        <Grid.Row style={{ display: 'flex', justifyContent: 'right' }}>
          <Button content="Translate" primary onClick={() => translate(en)} />
        </Grid.Row>
        <Grid.Row>
          <TextArea
            placeholder="Japanese Sentence"
            style={{ minHeight: 100, width: '100%' }}
            value={jp}
            onChange={(event: ChangeEvent<HTMLTextAreaElement>) => {
              const value = String(event.target.value);
              setJp(value);
            }}
          />
        </Grid.Row>
        {/* <AppError {...error} /> */}
        <Loading active={false} />
        <Button
          content="Submit"
          style={{ width: '100%', marginTop: '20px' }}
          color="teal"
          onClick={() => onSumit()}
        />
      </Grid>
    </>
  );
};

export default Component;
